import { useQueryClient } from '@tanstack/react-query';
import type { InfiniteData } from 'query';
import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { getContentObjectDetailQueryKey, getFeedKey } from 'features/feed/queries/keys';
import { type VotablePoll, patchPollVote } from '../utils';

export type UpdatePollVoteProperties = {
  action: 'unvote' | 'vote';
};

type FeedCacheItem = { poll?: { id: string } & VotablePoll };

export const useUpdatePollVote = ({ action }: UpdatePollVoteProperties) => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ choice, pollId }: { choice: string; pollId?: string }) => {
      queryClient.setQueriesData<VotablePoll>({ queryKey: getContentObjectDetailQueryKey({ id: pollId }) }, (poll) =>
        poll ? patchPollVote(poll, choice, action) : poll,
      );

      queryClient.setQueriesData<InfiniteData<FeedCacheItem[]>>({ queryKey: getFeedKey() }, (oldData) => {
        if (!oldData) {
          return oldData;
        }

        return {
          ...oldData,
          pages: oldData.pages.map((page) =>
            page.map((pageItem) =>
              pageItem.poll && pageItem.poll.id === pollId
                ? { ...pageItem, poll: patchPollVote(pageItem.poll, choice, action) }
                : pageItem,
            ),
          ),
        };
      });
    },
    [action, queryClient],
  );
};
